import { IFrequencyCap } from '../entities/frequency-caps';
import { defaultContextValues, IAction, IState } from './FrequencyCapsContext';

export type ActionTypes = 'SET_INITIAL' | 'UPDATE_INTERVAL' | 'UPDATE_MAX_MESSAGES' | 'RESET';

export function FrequencyCapsReducer(state: IState, action: IAction) {
  const { payload } = action;
  let newState: IState = null;

  switch (action.type) {
    case 'SET_INITIAL':
      let frequencyCap: IFrequencyCap = payload.frequencyCap;
      if (frequencyCap === undefined) {
        frequencyCap = { ...defaultContextValues.frequencyCap };
      }
      newState = {
        ...state,
        originalFrequencyCap: frequencyCap,
        frequencyCap: frequencyCap,
        isInitialised: true,
      };
      break;
    case 'RESET':
      newState = {
        ...state,
        frequencyCap: state.originalFrequencyCap,
      };
      break;
    case 'UPDATE_INTERVAL':
      newState = {
        ...state,
        frequencyCap: {
          ...state.frequencyCap,
          period: payload.interval,
        },
      };
      break;
    case 'UPDATE_MAX_MESSAGES':
      newState = {
        ...state,
        frequencyCap: {
          ...state.frequencyCap,
          amount: payload.maximum,
        },
      };
      break;
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
  return newState;
}
